import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import Toolbar from './components/Toolbar.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '',
      name: 'homelogin',
      component: () => import('./views/data/homelogin.vue')
    },
    {
      path: '/download/*',
      name: 'download',
      component: () => import('./views/data/downloadpdf.vue')
    },
    {
      path: '/',
      name: '',
      component: Toolbar,
      children: [
        {
          path: 'approveorder',
          name: 'approveorder',
          component: () => import('./views/data/approveorder.vue')
        },
        {
          path: 'summarysales',
          name: 'summarysales',
          component: () => import('./views/data/summarysales.vue')
        },
        {
          path: 'approvepayment',
          name: 'approvepayment',
          component: () => import('./views/data/approveconfirmpaymentorder.vue')
        },
        {
          path: 'manageproducts',
          name: 'manageproducts',
          component: () => import('./views/data/manageproducts.vue')
        },
        {
          path: 'exportorder',
          name: 'exportorder',
          component: () => import('./views/data/exportorder.vue')
        },
        {
          path: 'orderdetail',
          name: 'orderdetail',
          component: () => import('./views/data/orderdetail.vue')
        },
        {
          path: 'editorder/:order_id',
          name: 'editorder',
          component: () => import('./views/data/orderdetailedit.vue')
        },
        {
          path: 'managemember',
          name: 'managemember',
          component: () => import('./views/data/managemember.vue')
        },
        {
          path: 'manageadmin',
          name: 'manageadmin',
          component: () => import('./views/data/manageadmin.vue')
        },
        {
          path: 'managebank',
          name: 'managebank',
          component: () => import('./views/data/managebankaccount.vue')
        },
        {
          path: 'manageproductprices',
          name: 'manageproductprices',
          component: () => import('./views/data/Manageproductprices.vue')
        },
        {
          path: 'grouppricedetail*',
          name: 'grouppricedetail',
          component: () => import('./views/data/editmanaprice.vue')
        },
        {
          path: 'orderhistory',
          name: 'orderhistory',
          component: () => import('./views/data/orderhistory.vue')
        },
        {
          path: 'deliveryorder',
          name: 'deliveryorder',
          component: () => import('./views/data/deliveryorder.vue')
        },
        {
          path: 'recentexport',
          name: 'recentexport',
          component: () => import('./views/data/recentexport.vue')
        }
      ]
    }
  ]
})
